import React from "react";
import { useTranslation } from "react-i18next";
import {
    $Row,
    $Col,
    $Skeleton,
    $Typography,
    $AmountLabel,
    $DateLabel,
} from "us.common/components";
import moment from "moment";
import { DateFormats } from "us.collection.debtor/components/DebtorInfo/Constants";

type OtherInfoProps = {
    isFetchingOtherInformation: boolean;
    otherInfo: any;
};
/**
 * @description
 * OtherInfo Component
 * -------------------
 * This component displays additional debtor-related information such as:
 *  - Last login to the portal
 *  - Last payment amount and date
 *
 * Features:
 *  - Conditional rendering based on data availability
 *  - Validates dates before displaying
 *  - Formats amounts and dates using shared components
 */
const OtherInfo: React.FC<OtherInfoProps> = (props) => {
    const { t } = useTranslation();
    const { isFetchingOtherInformation, otherInfo } = props;

    return (
        <div className="pl-1 pb-4">
            <$Skeleton loading={isFetchingOtherInformation}>
                <$Row gutter={16}>
                    {moment.utc(otherInfo?.lastLoginPortal).isValid() &&
                        moment
                            .utc(otherInfo?.lastLoginPortal)
                            .isAfter(moment.utc(DateFormats.MIN_DATE)) && (
                            <$Col span={6}>
                                <$Typography.Text type="secondary" className="mb-0 mt-0">
                                    {t("US.COLLECTION.DEBTOR:GENERAL.LAST_LOGIN_PORTAL")}
                                </$Typography.Text>
                                <h3 className="mb-0 mt-0">
                                    <$DateLabel value={otherInfo?.lastLoginPortal} />
                                </h3>
                            </$Col>
                        )}
                    {otherInfo?.payment != 0 && (
                        <$Col span={12}>
                            <$Typography.Text type="secondary" className="mb-0 mt-0">
                                {t("US.COLLECTION.DEBTOR:GENERAL.LAST_PAYMENT")}
                            </$Typography.Text>
                            <div className="d-flex align-items-end">
                                <h3 className="mb-0 mt-0">
                                    <$AmountLabel value={Number(otherInfo?.payment)} />
                                    {otherInfo?.payment == 0 && "-"}
                                </h3>
                                <h3 className="mb-0 mt-0 ml-2">
                                    {moment.utc(otherInfo?.lastPaymentDate).isValid() &&
                                        moment
                                            .utc(otherInfo?.lastPaymentDate)
                                            .isAfter(moment.utc(DateFormats.MIN_DATE)) && (
                                            <$DateLabel value={otherInfo?.lastPaymentDate} />
                                        )}
                                </h3>
                                {/* </span> */}
                            </div>
                        </$Col>
                    )}
                </$Row>
            </$Skeleton>
        </div>
    );
};

export default OtherInfo;
